import React from "react";
import LineChart from "../../chart/LineChart";
import useTransmissionReportLog from "../../transmission_report_log/useTransmissionReportLog";

const UserProgressAnalyticChart = () => {
  const { userTransmissionProgressData, getChartOptions } =
    useTransmissionReportLog();

  return (
    <LineChart
      options={getChartOptions()}
      data={userTransmissionProgressData?.chartData}
    />
  );
};

export default UserProgressAnalyticChart;
